module.exports = __webpack_public_path__ + "static/img/6.6c4daa7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/2/eng/6.png
// module id = 7zIp
// module chunks = 0